<template>
  <div>
      <v-card>
    <v-card-title>
        <v-btn 
        color="primary"
        @click="addDevice"
        >Add Device</v-btn>
        <div class="ma-1"></div>

        <v-file-input
          truncate-length="15"
          label="Import CSV with field macaddress,name,psk,remark"
          accept=".csv"
          @change="read_csv"
          :rules="csv_rules"
        ></v-file-input>
        <span class="ml-5 mr-5 text-body-1"><p><a href="iot1.csv">Download CSV file example</a></p></span>      
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      
      <v-spacer></v-spacer>
      <v-chip color="primary" outlined class="ma-2"> {{this.user_info.cmuitaccount_name}} </v-chip>
      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="Admin" v-if="this.user_info.type=='admin'">
              <v-list-item-title>Admin page</v-list-item-title>
            </v-list-item>
            <v-list-item to="Logs">
              <v-list-item-title>Logs</v-list-item-title>
            </v-list-item>
            <v-list-item target="_blank" href="https://cmu.to/ipsk">
              <v-list-item-title>Help and support</v-list-item-title>
            </v-list-item>
            <v-list-item to="Logout">
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
              
    </v-card-title>
      
    <v-data-table
      :headers="headers"
      :items="devices"
      :search="search"
      :loading="this.loading"
      loading-text="Loading... Please wait"
      :sort-by="['updatetime']"
      :sort-desc="['ture']"
    >

    <template v-slot:top> 
        <v-toolbar
        flat
        >
        <v-dialog v-model="dialogDelete" max-width="440px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this device?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">No</v-btn>
              <v-btn color="red darken-1" text @click="deleteItemConfirm">Yes</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAdd" max-width="500px">   
          <v-form ref="form" v-model="valid">       
          <v-card>
            <v-card-title>
              <span class="text-h5">Add device</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="addItem.macaddress"
                      label="MAC Address"
                      required
                      :rules="macaddress_rules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="addItem.name"
                      label="Name"
                      required
                      :rules="name_rule"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="addItem.psk"
                      label="PSK"
                      required
                      :rules="psk_rules"
                    ></v-text-field>
                    <v-btn color="blue" @click="gen_psk">Generate psk</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="addItem.remark"
                      label="Remark"
                      :rules="remark_rules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAdd"
              >
                Cancel
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :disabled="!valid"                
                @click="add"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogUpdate" max-width="500px">   
          <v-form ref="form" v-model="valid">       
          <v-card>
            <v-card-title>
              <span class="text-h5">Update device</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.macaddress"
                      label="MAC Address"
                      required
                      :disabled=true
                      :rules="macaddress_rules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                      required
                      :rules="name_rule"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.psk"
                      label="PSK"
                      required
                      :rules="psk_rules"
                    ></v-text-field>
                    <v-btn color="blue" @click="gen_psk">Generate psk</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.remark"
                      label="Remark"
                      :rules="remark_rules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogUpdate=false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :disabled="!valid"                
                @click="updateDevice"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogCSV" max-width="600px">
          <v-card>
            <v-card-title>
              CSV Data
            </v-card-title>
            
            <v-card-text>
              <v-data-table
                :headers="csv_headers"
                :items="csv_devices"                
              >
              <template v-slot:item.valid="{ item }">
                <v-chip
                  :color="item.valid==='Yes'?'green':'red'"
                  dark
                >
                  {{ item.valid }}
                </v-chip>
              </template>
              </v-data-table>
            </v-card-text>  

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogCSV=false">Close</v-btn>
              <v-btn color="green darken-1" text :disabled="csv_valid.includes('No')" @click="import_csv" >Import</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>          
          </v-card>          
        </v-dialog>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon
        large
        :disabled="loading"
        @click="updateItem(item)"
      >
        mdi-square-edit-outline
      </v-icon>
      
      <v-icon
        large
        :disabled="loading"
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>

    </template>
    </v-data-table>
    
  </v-card>
  <div class="ma-5"></div>
  <v-col cols="12" sm="12" md="12">
      <v-alert outlined type="error" v-if="errorMsg.show && errorMsg.text.detail.code!='ER_DUP_ENTRY'">
        Error : {{errorMsg.text.statusText}} -> {{errorMsg.text.detail.message}}<br>
        Please try again or contact system administrator with detail infomation click <a @click="errorDetail = !errorDetail">here</a>

        <pre v-show="errorDetail">
        {{errorMsg.text}}
        </pre>
      </v-alert>
      <v-alert 
        border="left"
        colored-border
        type="warning"
        elevation="2"
       v-if="errorMsg.show && errorMsg.text.detail.code=='ER_DUP_ENTRY'">        
        <p>
          อุปกรณ์หมายเลข MAC Address {{ errorMsg.text.detail.message.split(' ')[2] }} ได้ถูกลงทะเบียนโดยผู้ใช้งานท่านอื่นแล้ว<br>
          โปรดตรวจสอบอีกครั้งว่าท่านไม่ได้กรอกหมายเลข MAC Address ผิด<br>
          หากท่านกดยืนยันว่าอุปกรณ์นี้เป็นของท่านจริง ระบบจะดึงอุปกรณ์นี้มาอยู่ภายใต้ความรับผิดชอบของท่านในทันที<br>
          ซึ่งส่งผลให้อุปกรณ์นี้จะหลุดออกจากระบบ และไม่สามารถใช้งานได้ภายใต้สิทธิ์ของผู้ใช้งานเดิม<br>
          ทั้งนี้ระบบจะส่งอีเมลแจ้งเตือนไปยังผู้ใช้งานเดิมให้ทราบ หากภายหลังตรวจสอบพบว่าไม่ใช่อุปกรณ์ของท่านจริง<br>
          และเป็นการกระทำโดยมีเจตนาที่จะสร้างความเดือดร้อนรำคาญให้กับผู้อื่น ท่านก็อาจจะมีความผิดในลักษณะของการนำข้อมูลเข้าสู่ระบบอันเป็นเท็จได้<br>
          จึงใคร่ขอให้ท่านโปรดตรวจสอบความถูกต้องอีกครั้งก่อนกดยืนยันในขั้นตอนต่อไป<br>
        </p>
        <v-btn color="warning" @click="claimDialog=true">ดึงอุปกรณ์ /claim</v-btn>
      </v-alert>
    </v-col>    
    <v-dialog v-model="claimDialog" max-width="440px">
      <v-card>
        <v-card-title class="text-h5">ท่านแน่ใจว่าต้องการดึงอปุกรณ์ <br> Are you sure you want to claim this device?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="claimDialog=false">No</v-btn>
          <v-btn color="orange darken-1" text @click="claimDevice">Yes</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";
import moment from "moment";
import csvtojson from 'csvtojson';
import Ajv from 'ajv';

export default  Vue.extend({
  name: "deviceList",
  data: () => ({
      headers: [
          { text: 'MAC Address', value:'macaddress' },
          { text: 'Name', value:'name' },
          { text: 'PSK', value:'psk' },
          { text: 'Remark', value:'remark' },
          { text: 'Last update', value:'updatetime' },
          { text: 'Actions', value: 'actions', sortable: false },
      ],
    devices: [],
    search: '',
    dialogDelete: false,
    editedItem: {},
    access_token: sessionStorage.getItem('access_token'),
    dialogAdd: false,
    dialogUpdate: false,
    addItem: {macaddress: "", name:"", psk:"", remark:""},
    valid: false,
    macaddress_rules: [
      v => !!v || 'MAC Address required.',
      v => /^[a-f0-9]{12}$/.test(v) || 'MAC Addresses must contain 12 characters only and contain letters a - f or numbers 0 - 9.'
    ],
    name_rule: [
      v => !!v || 'Required.',
      v => /^[a-zA-Z0-9-_ ]+$/.test(v) || 'Must contain letters or numbers or space only.',
      v => v.length < 50 || 'no more than 50 characters'
    ],
    remark_rules: [
      v => v.length < 255 || 'no more than 255 characters',
      v => /^[a-zA-Z0-9-_ ]+$/.test(v) || 'Must contain letters or numbers or space only.'
    ],
    psk_rules: [
      v => !!v || 'Required.',
      v => /^[a-z0-9]{8,32}$/.test(v) || 'PSK must contain 8 - 32 characters and contain letters a - z or numbers 0 - 9'
    ],
    errorMsg: {show:false, text:null},
    errorDetail: false,
    csv_rules: [
      v => !v || v.size < 2000000 || 'size should be less than 2 MB'
    ],
    dialogCSV: false,
    csv_headers: [
      { text: 'MAC Address', value:'macaddress'},
      { text: 'Name', value:'name'},
      { text: 'PSK', value:'psk'},
      { text: 'Remark', value:'remark' },
      { text: 'Valid', value:'valid' },
    ],
    csv_devices: [],
    csv_valid: [],
    device_schema: {},
    user_info: JSON.parse(sessionStorage.getItem('user_info')),
    loading: true,
    claimDialog: false,
    claimItem: {}
  }),
  mounted ()  {
      axios
      .get(
            this.$store.state.api_url+`/devices`,
            {headers: { Authorization: `Bearer ${this.access_token}`}}
          )
      .then((response)=>{
          this.devices = response.data        
          this.loading=false
      })
      .catch((error)=>{
        if (error.response) {        
            //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
            const errTxt = {
                status: error.response.status,
                statusText: error.response.statusText,
                detail: error.response.data
              }
              Object.assign(this.errorMsg,{show:true, text: errTxt}) 
        } else if (error.request) {            
            this.$router.push(`/Error`)
        } else {            
            this.$router.push(`/Error`)
        } 
      })
      
      axios
      .get(
        this.$store.state.api_url+`/schema/device`
      )
      .then((response)=>{
        this.device_schema = response.data
      })
      .catch((error)=>{
        if (error.response) {        
            //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
            const errTxt = {
                status: error.response.status,
                statusText: error.response.statusText,
                detail: error.response.data
              }
              Object.assign(this.errorMsg,{show:true, text: errTxt}) 
        } else if (error.request) {            
            this.$router.push(`/Error`)
        } else {            
            this.$router.push(`/Error`)
        }
      })      
  },

  watch : {
    dialogAdd (val) {
      if (!val) {
        Object.assign(this.addItem, {macaddress: "", name:"", psk:"", remark:""})
      }
    },
    dialogCSV (val) {
      if (!val) {
        this.csv_valid=[]
        this.csv_devices=[]
      }
    },
    devices (val) {
      if(val.length) {
        this.loading=false
      }
    },
    'errorMsg.show' (val) {
      if (val) {
        this.loading=false
      }
    }
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deleteItem (item) { 
        this.editedIndex = this.devices.indexOf(item)
        this.editedItem = item
        this.dialogDelete = true
    },    
    closeDelete () {
        this.dialogDelete = false
    },
    deleteItemConfirm () {
        this.dialogDelete = false 
        this.loading=true
        axios
        .delete(
            this.$store.state.api_url+`/devices/${this.editedItem.macaddress}`,
            {headers: { Authorization: `Bearer ${this.access_token}`}}
        )
        .then(()=>{
            this.devices.splice(this.editedIndex,1)                       
        })
        .catch((error)=>{            
            if (error.response) {            
                //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
                const errTxt = {
                  status: error.response.status,
                  statusText: error.response.statusText,
                  detail: error.response.data
                }
                Object.assign(this.errorMsg,{show:true, text: errTxt}) 
            } else if (error.request) {
                this.$router.push(`/Error`)
            } else {                
                this.$router.push(`/Error`)
            } 
        })        
    },
    updateItem (item) {
      this.editedIndex = this.devices.indexOf(item)
      Object.assign(this.editedItem,item)
      this.dialogUpdate = true
    },
    updateDevice () {
      this.dialogUpdate=false
      const item = Object.assign({},this.editedItem,{updatetime: moment().format('YYYY-MM-DD HH:mm:ss')})
      this.loading=true
      axios.put(
        this.$store.state.api_url+`/devices`,
        [
          item
        ],
        {headers: { Authorization: `Bearer ${this.access_token}`}}
      )
      .then(()=>{
        this.devices.splice(this.editedIndex,1)
        this.devices.push(item)
      })
      .catch((error)=>{
          if (error.response) {            
              //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
              const errTxt = {
                status: error.response.status,
                statusText: error.response.statusText,
                detail: error.response.data
              }
              Object.assign(this.errorMsg,{show:true, text: errTxt})              
          } else if (error.request) {
              this.$router.push(`/Error`)
          } else {                
              this.$router.push(`/Error`)
          } 
          
        })      
    },
    addDevice () {
        this.dialogAdd = true
        this.errorMsg.show = false
    },
    closeAdd () {      
      this.dialogAdd = false
    },
    add () {
        const item = Object.assign({},this.addItem,{updatetime: moment().format('YYYY-MM-DD HH:mm:ss')})
        this.claimItem = item
        this.dialogAdd = false
        this.loading=true
        axios
        .post(
          this.$store.state.api_url+`/devices`,
          [
            item
          ],
          {headers: { Authorization: `Bearer ${this.access_token}`}}
        )
        .then(()=>{
          this.devices.push(item)
        })
        .catch((error)=>{
          if (error.response) {            
              //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
              const errTxt = {
                status: error.response.status,
                statusText: error.response.statusText,
                detail: error.response.data
              }
              Object.assign(this.errorMsg,{show:true, text: errTxt})              
          } else if (error.request) {
              this.$router.push(`/Error`)
          } else {                
              this.$router.push(`/Error`)
          } 
          
        })        
    },
    gen_psk (){
      Object.assign(this.addItem,{psk: Math.random().toString(36).substring(2, 10)})
      Object.assign(this.editedItem,{psk: Math.random().toString(36).substring(2, 10)})
    },
    read_csv (file) {
      if (file && file.size < 2000000) {                  
        file.text().then((text)=>{
          csvtojson().fromString(text).then((json)=>{
            //console.log(json);
            const ajv = new Ajv({allErrors:true, removeAdditional:'all' })            
            this.csv_devices = json.map((e)=>{
              if (ajv.validate(this.device_schema,e)) {
                e.valid = "Yes"
                this.csv_valid.push('Yes')
              } else {
                e.valid = "No"
                this.csv_valid.push('No')
              }
              return e
            })
            this.dialogCSV=true
          })
        })
        
      }      
    },
    import_csv () {
      this.loading=true
      const devices_import = this.csv_devices.map(e => e)
      this.dialogCSV = false
      axios.post(
        this.$store.state.api_url+`/devices`,
        devices_import,
        {headers: { Authorization: `Bearer ${this.access_token}`}}
      )
      .then(()=>{
        devices_import.forEach((e)=>{
          e.updatetime = moment().format('YYYY-MM-DD HH:mm:ss')
          this.devices.push(e)
        })
      })
      .catch((error)=>{
        if (error.response) {            
            //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
            const errTxt = {
              status: error.response.status,
              statusText: error.response.statusText,
              detail: error.response.data
            }
            Object.assign(this.errorMsg,{show:true, text: errTxt})              
        } else if (error.request) {
            this.$router.push(`/Error`)
        } else {                
            this.$router.push(`/Error`)
        }
      })
    },
    claimDevice () {
      const item = Object.assign(this.claimItem,{updatetime: moment().format('YYYY-MM-DD HH:mm:ss')})
      this.claimDialog=false
      this.loading=true
      axios.put(
        this.$store.state.api_url+`/devices/claim`,
        [
          item
        ],
        {headers: { Authorization: `Bearer ${this.access_token}`}}
      )
      .then(()=>{
        this.devices.push(item)
        this.errorMsg.show = false
      })
      .catch((error)=>{
        if (error.response) {            
            //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
            const errTxt = {
              status: error.response.status,
              statusText: error.response.statusText,
              detail: error.response.data
            }
            Object.assign(this.errorMsg,{show:true, text: errTxt})              
        } else if (error.request) {
            this.$router.push(`/Error`)
        } else {                
            this.$router.push(`/Error`)
        } 
        
      })
    }
  }
});
</script>
